export const USER_PROPERTIES = {
    "AVATAR": "avatar",
    "BGRCOLOR": "bgrColor",
    "ID": "id",
    "ROLE": "role",
    "USERNAME": "username",
    "SYSTEM_ADMIN": "systemAdmin",
    "DISPLAY_NAME": "displayName",
    "EMAIL": "email"
}